export default "__VITE_PUBLIC_ASSET__8f4dcb64__"